<template>
  <div class="fit">
    <div class="header tw-rounded-md tw-p-4 tw-shadow-sm">
      <div class="tw-flex tw-flex-row tw-justify-between tw-items-center">
        <div class="tw-w-1/4 tw-p-2 tw-flex tw-flex-col tw-items-center">
          <span class="tw-text-gray-600 tw-text-sm"><translate>CANCELLATION_PENDING</translate></span>
          <span class="tw-text-gray-800 tw-text-2xl tw-font-medium">{{ metricPending }}</span>
        </div>
        <div
          v-for="item in headerItems"
          :key="item.title"
          class="tw-w-1/4 tw-p-2 tw-flex tw-flex-col tw-items-center"
        >
          <span class="tw-text-gray-600 tw-text-sm">{{ item.name }}</span>
          <span class="tw-text-gray-800 tw-text-2xl tw-font-medium">{{ item.count }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>import { Component, Vue } from 'vue-property-decorator'
import { invoiceSettlementType } from './invoiceSettlementType.js'
import { invoiceSettlementStatus } from 'src/shared/inf-tabela-descricao/InvoiceSettlementStatus.enum.js'

@Component({
  name: 'AnalyzeInvoiceSettlementTableHeader',
  props: {
    apiResponse: {
      type: Object,
      required: true
    }
  }
})

export default class AnalyzeInvoiceSettlementTableHeader extends Vue {
  get invoiceSettlementType () {
    return invoiceSettlementType()
  }

  get invoiceSettlementStatus () {
    return invoiceSettlementStatus()
  }

  get metricPending () {
    const registros = this.apiResponse || []

    const pendingRegistros = registros.filter(registro => {
      return registro.invoiceSettlementStatus === this.invoiceSettlementStatus.PENDING.key
    })

    return pendingRegistros.length
  }

  get headerItems () {
    const registrosAPI = this.apiResponse || []

    const labelTypeMap = {}
    Object.entries(this.invoiceSettlementType).forEach(([key, value]) => {
      if (value.number) {
        labelTypeMap[value.number] = value.label
      }
    })

    const countsByType = {}
    registrosAPI.forEach(reg => {
      const typeId = reg.invoiceSettlementType
      if (typeId !== undefined && typeId !== null) {
        if (countsByType[typeId]) {
          countsByType[typeId]++
        } else {
          countsByType[typeId] = 1
        }
      } else {
        console.warn('Registro com invoiceSettlementType nulo/indefinido:', reg)
      }
    })

    return Object.entries(labelTypeMap).map(([typeId, name]) => {
      const count = countsByType[typeId] ? countsByType[typeId] : 0
      return {
        title: typeId,
        name: name,
        count: count
      }
    }).sort((a, b) => {
      const order = [
        this.invoiceSettlementType.EXEMPTION?.number + '',
        this.invoiceSettlementType.PARTIAL_WRITE_OFF?.number + '',
        this.invoiceSettlementType.TOTAL_WRITE_OFF?.number + ''
      ].filter(Boolean)

      return order.indexOf(a.title) - order.indexOf(b.title)
    })
  }
}
</script>
<style scoped>
@import "tailwindcss/utilities";
.header {
  background-color: #f1f1f1;
}
</style>
